import React from "react";
import { Container, Row, Col, Card, Image, ListGroup } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const GitHubBlog = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 div-shadow mb-3">
          <h1 className="head-color">GitHub: The Ultimate Platform for Developers</h1>
          <p className="text-dark">
            GitHub is one of the most powerful platforms for developers, providing a collaborative environment for coding, version control, and open-source contributions.
          </p>

          <Row className="mt-3 text-center">
            <Col md={12}>
              <Image src="/graphics/images/github.png" alt="Git" fluid />
            </Col>
          </Row><br/>

          <h4>What is GitHub?</h4>
          <p className="text-dark">
            GitHub is a web-based platform that provides <strong>Git</strong> version control and collaboration features. It allows developers to host repositories, track changes, and collaborate with others.
          </p>

          <h4>Key Features of GitHub:</h4>
          <ul>
          <li><strong>Repositories:</strong> Store your code and project files.</li>
          <li><strong>Commits & Branching:</strong> Work on different versions of a project.</li>
          <li><strong>Pull Requests:</strong> Collaborate with others.</li>
          <li><strong>Issues & Discussions:</strong> Report bugs and track tasks.</li>
          <li><strong>Actions & CI/CD:</strong> Automate workflows.</li>
          </ul>

          <h4>Why Should You Use GitHub?</h4>
          <ol>
            <li><strong>Version Control & Collaboration</strong></li>
            <p>GitHub allows multiple developers to work on the same project efficiently using <b>branching and merging.</b></p>
            
            <li><strong>Open-Source Contributions</strong></li>
            <p>Many popular projects like Linux, React, and TensorFlow are hosted on GitHub.</p>

            <li><strong>Project Management Tools</strong></li>
            <p>GitHub offers built-in tools like <b>Kanban boards, Milestones, and Issues</b> for managing development tasks.</p>

            <li><strong>Continuous Integration & Deployment (CI/CD)</strong></li>
            <p>With <b>GitHub Actions,</b> developers can automate testing and deployments.</p>

            <li><strong>Secure & Reliable Hosting</strong></li>
            <p>GitHub offers <b>private and public repositories</b> with secure hosting.</p>
          </ol>

          <h4>Getting Started with GitHub</h4>
          <h5>Step 1: Create a GitHub Account</h5>
          <p>Sign up at <a href="https://github.com/" target="_blank" rel="noopener noreferrer">GitHub</a>.</p>

          <h5>Step 2: Create a New Repository</h5>
          <ol>
            <li>Click the "+" button and select <b>"New repository"</b>.</li>
            <li>Give your repository a name.</li>
            <li>Choose between <b>public or private</b>.</li>
            <li>Click <b>"Create repository"</b>.</li>
          </ol>

          <h5>Step 3: Clone the Repository Locally</h5>
          <pre>git clone https://github.com/yourusername/repository-name.git</pre>

          <h5>Step 4: Make Changes & Commit</h5>
          <pre>git add .</pre>
          <pre>git commit -m "Initial commit"</pre>
          <pre>git push origin main</pre>

          <h5>Step 5: Collaborate with Others</h5>
          <ul>
            <li>Fork repositories and contribute to open-source projects.</li>
            <li>Submit pull requests to suggest changes.</li>
            <li>Use issues to report bugs or request features.</li>
          </ul>

          <h4>Advanced GitHub Features</h4>
          <ul>
              <li><strong>GitHub Actions:</strong> Automate workflows.</li>
              <li><strong>GitHub Pages:</strong> Host static websites.</li>
              <li><strong>Security & Code Review:</strong> Use Dependabot for vulnerability scanning.</li>
          </ul>

          <h4>Conclusion</h4>
          <p>GitHub is an essential tool for modern software development. Whether working alone or in a team, it helps manage code, collaborate, and automate workflows efficiently. Start using GitHub today and take your development skills to the next level!</p>

          <p>Do you use GitHub for your projects? Share your experience in the comments!</p>
        </Col>

        <Col sm={3} className="recent-post">
          <Card className="bg-white p-4 mb-3 div-shadow">
            <h4 className="head-color">Recent Post</h4>
            <RecentPost />
          </Card>

          <Card className="bg-white p-4 div-shadow">
            <h4 className="mt-4 head-color">Recent Comment</h4>
            <p style={{ color: "#85929e" }}>No Comments to Show</p>
          </Card>

          <div className="blogadshowright mt-5"></div>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default GitHubBlog;